import { ShieldAlert } from 'lucide-react';
import type { RouteObject } from 'react-router-dom';
import { Outlet, useSearchParams } from 'react-router-dom';
import {
	AdminAuthProvider,
	AdminDashboardPage,
	AdminFeatureRequestPage,
	AdminLoginPage,
	AdminProjectPage,
	AdminSignUpPage,
} from '@/modules/admin';
import { AdminGuardedRoute } from '@/modules/admin/components/AdminLayout';
import { UserFeedbackPage } from '@/modules/user-feedback';
import { StatusPlaceholder } from '@/ui/components/ui/status-placeholder';
import { ROUTES } from './routes.constants';

function EmbedGuardedRoute() {
	const [params] = useSearchParams();
	if (
		!params.get('projectId') ||
		!params.get('pageHmac') ||
		!params.get('timestamp')
	) {
		return (
			<div className='min-h-screen bg-background flex items-center justify-center px-6'>
				<StatusPlaceholder
					icon={ShieldAlert}
					title='Missing embed parameters'
					description='This embed link is missing required parameters.'
					variant='error'
				/>
			</div>
		);
	}
	return <UserFeedbackPage />;
}

export const routes: RouteObject[] = [
	{
		path: ROUTES.EMBED_FEEDBACK,
		element: <EmbedGuardedRoute />,
	},
	{
		path: ROUTES.FEEDBACK,
		element: <UserFeedbackPage />,
	},
	{
		element: (
			<AdminAuthProvider>
				<Outlet />
			</AdminAuthProvider>
		),
		children: [
			{
				path: ROUTES.HOME,
				element: <AdminLoginPage />,
			},
			{
				path: '/admin',
				children: [
					{
						path: 'register',
						element: <AdminSignUpPage />,
					},
					{
						index: true,
						element: (
							<AdminGuardedRoute>
								<AdminDashboardPage />
							</AdminGuardedRoute>
						),
					},
					{
						path: 'projects/:id',
						element: (
							<AdminGuardedRoute>
								<AdminProjectPage />
							</AdminGuardedRoute>
						),
					},
					{
						path: 'projects/:id/feature-requests/:frId',
						element: (
							<AdminGuardedRoute>
								<AdminFeatureRequestPage />
							</AdminGuardedRoute>
						),
					},
				],
			},
		],
	},
];
